{
  "schemaVersion": "1.0.0",
  "generatedAt": "2026-08-09T08:12:38.290Z",
  "count": 232,
  "nodes": [
    {
      "id": "flow-control.start",
      "name": "Start",
      "category": "flow-control",
      "ports": {
        "inputs": [],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "description",
          "label": "Description",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.end",
      "name": "End",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": []
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "description",
          "label": "Description",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.delay",
      "name": "Delay",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "duration",
          "label": "Duration",
          "type": "number",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "unit",
          "label": "Unit",
          "type": "select",
          "options": [
            {
              "label": "Seconds",
              "value": "seconds"
            },
            {
              "label": "Minutes",
              "value": "minutes"
            },
            {
              "label": "Hours",
              "value": "hours"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.wait",
      "name": "Wait",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "duration",
          "label": "Duration",
          "type": "number",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "unit",
          "label": "Unit",
          "type": "select",
          "options": [
            {
              "label": "Seconds",
              "value": "seconds"
            },
            {
              "label": "Minutes",
              "value": "minutes"
            },
            {
              "label": "Hours",
              "value": "hours"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.manual-task",
      "name": "Manual Task",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Underwriter",
              "value": "Underwriter"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Operations Team",
              "value": "Operations Team"
            },
            {
              "label": "Current User",
              "value": "Current User"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "instructions",
          "label": "Instructions",
          "type": "textarea",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.parallel",
      "name": "Parallel",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "branchCount",
          "label": "Branch Count",
          "type": "number",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.merge",
      "name": "Merge",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "mergeStrategy",
          "label": "Merge Strategy",
          "type": "select",
          "options": [
            {
              "label": "All",
              "value": "all"
            },
            {
              "label": "Any",
              "value": "any"
            },
            {
              "label": "First",
              "value": "first"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.loop",
      "name": "Loop",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "maxIterations",
          "label": "Max Iterations",
          "type": "number",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "breakCondition",
          "label": "Break Condition",
          "type": "code",
          "language": "expression",
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.sub-workflow",
      "name": "Sub Workflow",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "workflowId",
          "label": "Workflow",
          "type": "select",
          "dynamicOptions": "workflows",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.go-to",
      "name": "Go To",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "targetStepId",
          "label": "Target Step",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.terminate",
      "name": "Terminate",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": []
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "description",
          "label": "Description",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.success",
      "name": "Success",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": []
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "description",
          "label": "Description",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.failure",
      "name": "Failure",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": []
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "description",
          "label": "Description",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.continue",
      "name": "Continue",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "description",
          "label": "Description",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "flow-control.retry",
      "name": "Retry",
      "category": "flow-control",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "maxAttempts",
          "label": "Max Attempts",
          "type": "number",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "backoffSeconds",
          "label": "Backoff (seconds)",
          "type": "number",
          "required": true,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "applicant.select-applicant-type",
      "name": "Select Applicant Type",
      "category": "applicant",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "applicantTypes",
          "label": "Applicant Types",
          "type": "multiselect",
          "options": [
            {
              "label": "Individual",
              "value": "Individual"
            },
            {
              "label": "Joint",
              "value": "Joint"
            },
            {
              "label": "Corporate",
              "value": "Corporate"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "applicant.select-customer-status",
      "name": "Select Customer Status",
      "category": "applicant",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "statusOptions",
          "label": "Status Options",
          "type": "multiselect",
          "options": [
            {
              "label": "New",
              "value": "New"
            },
            {
              "label": "Existing",
              "value": "Existing"
            },
            {
              "label": "Reactivated",
              "value": "Reactivated"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "applicant.create-opportunity",
      "name": "Create Opportunity",
      "category": "applicant",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "productType",
          "label": "Product Type",
          "type": "select",
          "options": [
            {
              "label": "Personal Loan",
              "value": "Personal Loan"
            },
            {
              "label": "Home Loan",
              "value": "Home Loan"
            },
            {
              "label": "Auto Loan",
              "value": "Auto Loan"
            },
            {
              "label": "Business Loan",
              "value": "Business Loan"
            },
            {
              "label": "Gold Loan",
              "value": "Gold Loan"
            },
            {
              "label": "Education Loan",
              "value": "Education Loan"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "branchId",
          "label": "Branch",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "sourceChannel",
          "label": "Source Channel",
          "type": "select",
          "options": [
            {
              "label": "Web",
              "value": "Web"
            },
            {
              "label": "Mobile App",
              "value": "Mobile App"
            },
            {
              "label": "Branch",
              "value": "Branch"
            },
            {
              "label": "Call Center",
              "value": "Call Center"
            },
            {
              "label": "DSA/Partner",
              "value": "DSA/Partner"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "applicant.load-opportunity",
      "name": "Load Opportunity",
      "category": "applicant",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "opportunityId",
          "label": "Opportunity",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "applicant.update-opportunity",
      "name": "Update Opportunity",
      "category": "applicant",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "opportunityId",
          "label": "Opportunity",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "applicant.lock-opportunity",
      "name": "Lock Opportunity",
      "category": "applicant",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "opportunityId",
          "label": "Opportunity",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "reason",
          "label": "Reason",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "applicant.close-opportunity",
      "name": "Close Opportunity",
      "category": "applicant",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "opportunityId",
          "label": "Opportunity",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "reason",
          "label": "Reason",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "applicant.clone-opportunity",
      "name": "Clone Opportunity",
      "category": "applicant",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "sourceOpportunityId",
          "label": "Source Opportunity",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "customer.search-customer",
      "name": "Search Customer",
      "category": "customer",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "searchFields",
          "label": "Search Fields",
          "type": "multiselect",
          "options": [
            {
              "label": "Name",
              "value": "Name"
            },
            {
              "label": "DOB",
              "value": "DOB"
            },
            {
              "label": "Aadhar Number",
              "value": "Aadhar Number"
            },
            {
              "label": "PAN Card",
              "value": "PAN Card"
            },
            {
              "label": "Contact Number",
              "value": "Contact Number"
            },
            {
              "label": "Organization Name",
              "value": "Organization Name"
            },
            {
              "label": "Date of Incorporation",
              "value": "Date of Incorporation"
            },
            {
              "label": "PAN Number",
              "value": "PAN Number"
            },
            {
              "label": "GST Number",
              "value": "GST Number"
            },
            {
              "label": "Incorporation Registration Number",
              "value": "Incorporation Registration Number"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "matchThreshold",
          "label": "Match Threshold",
          "type": "number",
          "min": 0,
          "max": 100,
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "customer.create-customer",
      "name": "Create Customer",
      "category": "customer",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "fieldMapping",
          "label": "Field Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "customer.update-customer",
      "name": "Update Customer",
      "category": "customer",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "fieldMapping",
          "label": "Field Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "customer.merge-customer",
      "name": "Merge Customer",
      "category": "customer",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "primaryCustomerId",
          "label": "Primary Customer",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "secondaryCustomerId",
          "label": "Secondary Customer",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "customer.customer-dedupe",
      "name": "Customer Dedupe",
      "category": "customer",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "matchFields",
          "label": "Match Fields",
          "type": "multiselect",
          "options": [
            {
              "label": "PAN",
              "value": "PAN"
            },
            {
              "label": "Aadhaar",
              "value": "Aadhaar"
            },
            {
              "label": "Phone",
              "value": "Phone"
            },
            {
              "label": "Email",
              "value": "Email"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "matchThreshold",
          "label": "Match Threshold",
          "type": "number",
          "min": 0,
          "max": 100,
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "customer.customer-override",
      "name": "Customer Override",
      "category": "customer",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "overrideField",
          "label": "Override Field",
          "type": "select",
          "options": [
            {
              "label": "PAN",
              "value": "PAN"
            },
            {
              "label": "Aadhaar",
              "value": "Aadhaar"
            },
            {
              "label": "Phone",
              "value": "Phone"
            },
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "Address",
              "value": "Address"
            },
            {
              "label": "Name",
              "value": "Name"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "overrideValue",
          "label": "Override Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "approverRole",
          "label": "Approver Role",
          "type": "select",
          "options": [
            {
              "label": "Manager",
              "value": "Manager"
            },
            {
              "label": "Credit",
              "value": "Credit"
            },
            {
              "label": "Risk",
              "value": "Risk"
            },
            {
              "label": "Compliance",
              "value": "Compliance"
            },
            {
              "label": "Legal",
              "value": "Legal"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "customer.load-existing-customer",
      "name": "Load Existing Customer",
      "category": "customer",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "customerId",
          "label": "Customer",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "customer.create-co-applicant",
      "name": "Create Co-Applicant",
      "category": "customer",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "relationshipType",
          "label": "Relationship Type",
          "type": "select",
          "options": [
            {
              "label": "Spouse",
              "value": "Spouse"
            },
            {
              "label": "Parent",
              "value": "Parent"
            },
            {
              "label": "Sibling",
              "value": "Sibling"
            },
            {
              "label": "Child",
              "value": "Child"
            },
            {
              "label": "Friend",
              "value": "Friend"
            },
            {
              "label": "Business Partner",
              "value": "Business Partner"
            },
            {
              "label": "Other",
              "value": "Other"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "applicantFields",
          "label": "Applicant Fields",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "customer.add-guarantor",
      "name": "Add Guarantor",
      "category": "customer",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "relationshipType",
          "label": "Relationship Type",
          "type": "select",
          "options": [
            {
              "label": "Spouse",
              "value": "Spouse"
            },
            {
              "label": "Parent",
              "value": "Parent"
            },
            {
              "label": "Sibling",
              "value": "Sibling"
            },
            {
              "label": "Child",
              "value": "Child"
            },
            {
              "label": "Friend",
              "value": "Friend"
            },
            {
              "label": "Business Partner",
              "value": "Business Partner"
            },
            {
              "label": "Other",
              "value": "Other"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "applicantFields",
          "label": "Applicant Fields",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "customer.household-lookup",
      "name": "Household Lookup",
      "category": "customer",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "matchFields",
          "label": "Match Fields",
          "type": "multiselect",
          "options": [
            {
              "label": "Address",
              "value": "Address"
            },
            {
              "label": "Phone",
              "value": "Phone"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.render-form",
      "name": "Render Form",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formId",
          "label": "Form",
          "type": "select",
          "dynamicOptions": "forms",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "formVersionId",
          "label": "Form Version",
          "type": "select",
          "dynamicOptions": "formVersions",
          "required": false,
          "tab": "setup",
          "description": "Defaults to the form’s active/published version if not set."
        },
        {
          "key": "mode",
          "label": "Mode",
          "type": "select",
          "options": [
            {
              "label": "Create",
              "value": "create"
            },
            {
              "label": "Edit",
              "value": "edit"
            },
            {
              "label": "View",
              "value": "view"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.load-form",
      "name": "Load Form",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formId",
          "label": "Form",
          "type": "select",
          "dynamicOptions": "forms",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "formVersionId",
          "label": "Form Version",
          "type": "select",
          "dynamicOptions": "formVersions",
          "required": false,
          "tab": "setup",
          "description": "Defaults to the form’s active/published version if not set."
        },
        {
          "key": "mode",
          "label": "Mode",
          "type": "select",
          "options": [
            {
              "label": "Create",
              "value": "create"
            },
            {
              "label": "Edit",
              "value": "edit"
            },
            {
              "label": "View",
              "value": "view"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.save-draft",
      "name": "Save Draft",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "autoSaveIntervalSeconds",
          "label": "Auto-Save Interval (seconds)",
          "type": "number",
          "required": true,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.submit-form",
      "name": "Submit Form",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "validateBeforeSubmit",
          "label": "Validate Before Submit",
          "type": "boolean",
          "default": true,
          "tab": "configure"
        },
        {
          "key": "apiEndpoint",
          "label": "API Endpoint",
          "type": "string",
          "tab": "setup",
          "description": "Optional — POST the submitted form data here after validation passes."
        },
        {
          "key": "payloadMapping",
          "label": "Payload Mapping",
          "type": "keyvalue",
          "dynamicOptions": "formFields",
          "tab": "setup",
          "description": "Optional — key is the API field name, value is the form field code to send under it. Leave empty to send the full submitted payload as-is."
        },
        {
          "key": "apiMethod",
          "label": "Method",
          "type": "select",
          "options": [
            {
              "label": "POST",
              "value": "POST"
            },
            {
              "label": "PUT",
              "value": "PUT"
            },
            {
              "label": "PATCH",
              "value": "PATCH"
            }
          ],
          "default": "POST",
          "tab": "configure"
        },
        {
          "key": "apiHeaders",
          "label": "Headers",
          "type": "keyvalue",
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.validate-form",
      "name": "Validate Form",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "rule",
          "label": "Cross-Field / Business Rule (Expression)",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Use this for checks a single field's own rule can't express: comparisons across multiple fields, business rules, or checks against data fetched earlier in the run (not on the form itself). Per-field required/min/max/pattern checks already run automatically on Submit Form — no need to duplicate them here."
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup",
          "description": "Shown to the user when the rule above fails."
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.reset-form",
      "name": "Reset Form",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "confirmBeforeReset",
          "label": "Confirm Before Reset",
          "type": "boolean",
          "default": true,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.pre-fill-form",
      "name": "Pre-fill Form",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "fieldMapping",
          "label": "Field Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.hide-fields",
      "name": "Hide Fields",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "targetFields",
          "label": "Target Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.show-fields",
      "name": "Show Fields",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "targetFields",
          "label": "Target Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.enable-fields",
      "name": "Enable Fields",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "targetFields",
          "label": "Target Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.disable-fields",
      "name": "Disable Fields",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "targetFields",
          "label": "Target Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.dynamic-sections",
      "name": "Dynamic Sections",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "sectionId",
          "label": "Section",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "visibilityCondition",
          "label": "Visibility Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.form-wizard",
      "name": "Form Wizard",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "steps",
          "label": "Steps",
          "type": "json",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.field-mapping",
      "name": "Field Mapping",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "sourceField",
          "label": "Source Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "targetField",
          "label": "Target Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.field-transformation",
      "name": "Field Transformation",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "sourceField",
          "label": "Source Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "transformExpression",
          "label": "Transform Expression",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "forms.custom-form-script",
      "name": "Custom Form Script",
      "category": "forms",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "script",
          "label": "Script",
          "type": "code",
          "language": "javascript",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.required-validation",
      "name": "Required Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.regex-validation",
      "name": "Regex Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "pattern",
          "label": "Pattern",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.cross-field-validation",
      "name": "Cross Field Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "compareField",
          "label": "Compare Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "operator",
          "label": "Operator",
          "type": "select",
          "options": [
            {
              "label": "==",
              "value": "=="
            },
            {
              "label": "!=",
              "value": "!="
            },
            {
              "label": ">",
              "value": ">"
            },
            {
              "label": "<",
              "value": "<"
            },
            {
              "label": ">=",
              "value": ">="
            },
            {
              "label": "<=",
              "value": "<="
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.formula-validation",
      "name": "Formula Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.unique-validation",
      "name": "Unique Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.range-validation",
      "name": "Range Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "min",
          "label": "Min",
          "type": "number",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "max",
          "label": "Max",
          "type": "number",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.age-validation",
      "name": "Age Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.pan-validation",
      "name": "PAN Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "dataTypeFilter": [
            "pan"
          ],
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.aadhar-validation",
      "name": "Aadhar Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "dataTypeFilter": [
            "aadhaar"
          ],
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.phone-validation",
      "name": "Phone Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "verified",
            "label": "Verified"
          },
          {
            "id": "failed",
            "label": "Failed"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "dataTypeFilter": [
            "mobile"
          ],
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "provider",
          "label": "OTP Provider",
          "type": "select",
          "options": [
            {
              "label": "MSG91",
              "value": "MSG91"
            },
            {
              "label": "Twilio",
              "value": "Twilio"
            },
            {
              "label": "Gupshup",
              "value": "Gupshup"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "timeoutSeconds",
          "label": "OTP Timeout (seconds)",
          "type": "number",
          "default": 120,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.email-validation",
      "name": "Email Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "dataTypeFilter": [
            "email"
          ],
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.business-validation",
      "name": "Business Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.if-validation",
      "name": "IF Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "validation.custom-validation",
      "name": "Custom Validation",
      "category": "validation",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "field",
          "label": "Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "errorMessage",
          "label": "Error Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "script",
          "label": "Validation Script",
          "type": "code",
          "language": "javascript",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.upload-document",
      "name": "Upload Document",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "documentType",
          "label": "Document Type",
          "type": "select",
          "options": [
            {
              "label": "PAN Card",
              "value": "PAN Card"
            },
            {
              "label": "Aadhaar Card",
              "value": "Aadhaar Card"
            },
            {
              "label": "Passport",
              "value": "Passport"
            },
            {
              "label": "Bank Statement",
              "value": "Bank Statement"
            },
            {
              "label": "Salary Slip",
              "value": "Salary Slip"
            },
            {
              "label": "Photograph",
              "value": "Photograph"
            },
            {
              "label": "Signature",
              "value": "Signature"
            },
            {
              "label": "Other",
              "value": "Other"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "maxSizeMB",
          "label": "Max Size (MB)",
          "type": "number",
          "default": 10,
          "tab": "configure"
        },
        {
          "key": "allowedFormats",
          "label": "Allowed Formats",
          "type": "multiselect",
          "options": [
            {
              "label": "PDF",
              "value": "PDF"
            },
            {
              "label": "JPG",
              "value": "JPG"
            },
            {
              "label": "PNG",
              "value": "PNG"
            },
            {
              "label": "TIFF",
              "value": "TIFF"
            }
          ],
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": true,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.scan-document",
      "name": "Scan Document",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "scanQuality",
          "label": "Scan Quality",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            }
          ],
          "required": true,
          "tab": "configure"
        },
        {
          "key": "documentType",
          "label": "Document Type",
          "type": "select",
          "options": [
            {
              "label": "PAN Card",
              "value": "PAN Card"
            },
            {
              "label": "Aadhaar Card",
              "value": "Aadhaar Card"
            },
            {
              "label": "Passport",
              "value": "Passport"
            },
            {
              "label": "Bank Statement",
              "value": "Bank Statement"
            },
            {
              "label": "Salary Slip",
              "value": "Salary Slip"
            },
            {
              "label": "Photograph",
              "value": "Photograph"
            },
            {
              "label": "Signature",
              "value": "Signature"
            },
            {
              "label": "Other",
              "value": "Other"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": true,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.ocr-document",
      "name": "OCR Document",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "extractFields",
          "label": "Extract Fields",
          "type": "multiselect",
          "options": [
            {
              "label": "Name",
              "value": "Name"
            },
            {
              "label": "Date of Birth",
              "value": "Date of Birth"
            },
            {
              "label": "Address",
              "value": "Address"
            },
            {
              "label": "ID Number",
              "value": "ID Number"
            },
            {
              "label": "Issue Date",
              "value": "Issue Date"
            },
            {
              "label": "Expiry Date",
              "value": "Expiry Date"
            },
            {
              "label": "Photo",
              "value": "Photo"
            },
            {
              "label": "Signature",
              "value": "Signature"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "documents.verify-document",
      "name": "Verify Document",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "comparisonFields",
          "label": "Comparison Fields",
          "type": "multiselect",
          "options": [
            {
              "label": "Name",
              "value": "Name"
            },
            {
              "label": "Date of Birth",
              "value": "Date of Birth"
            },
            {
              "label": "Address",
              "value": "Address"
            },
            {
              "label": "ID Number",
              "value": "ID Number"
            },
            {
              "label": "Issue Date",
              "value": "Issue Date"
            },
            {
              "label": "Expiry Date",
              "value": "Expiry Date"
            },
            {
              "label": "Photo",
              "value": "Photo"
            },
            {
              "label": "Signature",
              "value": "Signature"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.extract-data",
      "name": "Extract Data",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "extractFields",
          "label": "Extract Fields",
          "type": "multiselect",
          "options": [
            {
              "label": "Name",
              "value": "Name"
            },
            {
              "label": "Date of Birth",
              "value": "Date of Birth"
            },
            {
              "label": "Address",
              "value": "Address"
            },
            {
              "label": "ID Number",
              "value": "ID Number"
            },
            {
              "label": "Issue Date",
              "value": "Issue Date"
            },
            {
              "label": "Expiry Date",
              "value": "Expiry Date"
            },
            {
              "label": "Photo",
              "value": "Photo"
            },
            {
              "label": "Signature",
              "value": "Signature"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.compare-documents",
      "name": "Compare Documents",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "comparisonFields",
          "label": "Comparison Fields",
          "type": "multiselect",
          "options": [
            {
              "label": "Name",
              "value": "Name"
            },
            {
              "label": "Date of Birth",
              "value": "Date of Birth"
            },
            {
              "label": "Address",
              "value": "Address"
            },
            {
              "label": "ID Number",
              "value": "ID Number"
            },
            {
              "label": "Issue Date",
              "value": "Issue Date"
            },
            {
              "label": "Expiry Date",
              "value": "Expiry Date"
            },
            {
              "label": "Photo",
              "value": "Photo"
            },
            {
              "label": "Signature",
              "value": "Signature"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.merge-pdf",
      "name": "Merge PDF",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "sourceDocuments",
          "label": "Source Documents",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.generate-pdf",
      "name": "Generate PDF",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "select",
          "options": [
            {
              "label": "Loan Agreement",
              "value": "Loan Agreement"
            },
            {
              "label": "Sanction Letter",
              "value": "Sanction Letter"
            },
            {
              "label": "Application Form",
              "value": "Application Form"
            },
            {
              "label": "KYC Form",
              "value": "KYC Form"
            },
            {
              "label": "Custom Template",
              "value": "Custom Template"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFileName",
          "label": "Output File Name",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.generate-application-form",
      "name": "Generate Application Form",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "select",
          "options": [
            {
              "label": "Loan Agreement",
              "value": "Loan Agreement"
            },
            {
              "label": "Sanction Letter",
              "value": "Sanction Letter"
            },
            {
              "label": "Application Form",
              "value": "Application Form"
            },
            {
              "label": "KYC Form",
              "value": "KYC Form"
            },
            {
              "label": "Custom Template",
              "value": "Custom Template"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFileName",
          "label": "Output File Name",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.generate-agreement",
      "name": "Generate Agreement",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "select",
          "options": [
            {
              "label": "Loan Agreement",
              "value": "Loan Agreement"
            },
            {
              "label": "Sanction Letter",
              "value": "Sanction Letter"
            },
            {
              "label": "Application Form",
              "value": "Application Form"
            },
            {
              "label": "KYC Form",
              "value": "KYC Form"
            },
            {
              "label": "Custom Template",
              "value": "Custom Template"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFileName",
          "label": "Output File Name",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.download-documents",
      "name": "Download Documents",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "documentTypes",
          "label": "Document Types",
          "type": "multiselect",
          "options": [
            {
              "label": "PAN Card",
              "value": "PAN Card"
            },
            {
              "label": "Aadhaar Card",
              "value": "Aadhaar Card"
            },
            {
              "label": "Passport",
              "value": "Passport"
            },
            {
              "label": "Bank Statement",
              "value": "Bank Statement"
            },
            {
              "label": "Salary Slip",
              "value": "Salary Slip"
            },
            {
              "label": "Photograph",
              "value": "Photograph"
            },
            {
              "label": "Signature",
              "value": "Signature"
            },
            {
              "label": "Other",
              "value": "Other"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "format",
          "label": "Format",
          "type": "select",
          "options": [
            {
              "label": "Zip",
              "value": "zip"
            },
            {
              "label": "Individual",
              "value": "individual"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": true,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "documents.delete-document",
      "name": "Delete Document",
      "category": "documents",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "documentId",
          "label": "Document",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "reason",
          "label": "Reason",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "verification.pan-verification",
      "name": "PAN Verification",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.aadhar-verification",
      "name": "Aadhar Verification",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.gst-verification",
      "name": "GST Verification",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.ckyc",
      "name": "CKYC",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.cibil",
      "name": "CIBIL",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.experian",
      "name": "Experian",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.crif",
      "name": "CRIF",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.equifax",
      "name": "Equifax",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.bank-statement-analysis",
      "name": "Bank Statement Analysis",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.account-verification",
      "name": "Account Verification",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.penny-drop",
      "name": "Penny Drop",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.video-kyc",
      "name": "Video KYC",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.face-match",
      "name": "Face Match",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.liveness-detection",
      "name": "Liveness Detection",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.digilocker",
      "name": "Digilocker",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.nsdl",
      "name": "NSDL",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.karza",
      "name": "Karza",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.surepass",
      "name": "Surepass",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.signzy",
      "name": "Signzy",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "verification.perfios",
      "name": "Perfios",
      "category": "verification",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "provider",
          "label": "Provider",
          "type": "select",
          "options": [
            {
              "label": "Surepass",
              "value": "Surepass"
            },
            {
              "label": "Karza",
              "value": "Karza"
            },
            {
              "label": "Signzy",
              "value": "Signzy"
            },
            {
              "label": "Decentro",
              "value": "Decentro"
            },
            {
              "label": "Hyperverge",
              "value": "Hyperverge"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "timeout",
          "label": "Timeout (seconds)",
          "type": "number",
          "default": 30,
          "tab": "configure"
        },
        {
          "key": "retryOnFailure",
          "label": "Retry on Failure",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.emi-calculation",
      "name": "EMI Calculation",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        },
        {
          "key": "principal",
          "label": "Principal",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "rate",
          "label": "Rate",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "tenure",
          "label": "Tenure",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.eligibility-calculation",
      "name": "Eligibility Calculation",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.foir",
      "name": "FOIR",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.dti",
      "name": "DTI",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.ltv",
      "name": "LTV",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.roi-calculation",
      "name": "ROI Calculation",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.interest-calculation",
      "name": "Interest Calculation",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.processing-fee",
      "name": "Processing Fee",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.gst",
      "name": "GST",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.insurance-premium",
      "name": "Insurance Premium",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.stamp-duty",
      "name": "Stamp Duty",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.income-assessment",
      "name": "Income Assessment",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.obligation-assessment",
      "name": "Obligation Assessment",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.risk-score",
      "name": "Risk Score",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.loan-score",
      "name": "Loan Score",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "calculations.offer-calculation",
      "name": "Offer Calculation",
      "category": "calculations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formula",
          "label": "Formula",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup",
          "description": "Reference field codes as variables, e.g. income - obligations > 20000. Supports + - * / % ^ ( ), comparisons, and ?:."
        },
        {
          "key": "inputFields",
          "label": "Input Fields",
          "type": "multiselect",
          "dynamicOptions": "formFields",
          "dataTypeFilter": [
            "number",
            "currency"
          ],
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "roundingPrecision",
          "label": "Rounding Precision",
          "type": "number",
          "default": 2,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.if",
      "name": "IF",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "true",
            "label": "True"
          },
          {
            "id": "false",
            "label": "False"
          }
        ]
      },
      "properties": [
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.else",
      "name": "Else",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.switch",
      "name": "Switch",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "case-1",
            "label": "Case 1"
          },
          {
            "id": "case-2",
            "label": "Case 2"
          },
          {
            "id": "default",
            "label": "Default"
          }
        ]
      },
      "properties": [
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "cases",
          "label": "Cases",
          "type": "json",
          "default": "[{\"value\":\"case-1\",\"label\":\"Case 1\"},{\"value\":\"case-2\",\"label\":\"Case 2\"},{\"value\":\"default\",\"label\":\"Default\"}]",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.decision-table",
      "name": "Decision Table",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "rulesTable",
          "label": "Rules Table",
          "type": "json",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.rule-set",
      "name": "Rule Set",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "rules",
          "label": "Rules",
          "type": "json",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.score-card",
      "name": "Score Card",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "rulesTable",
          "label": "Rules Table",
          "type": "json",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.eligibility-rule",
      "name": "Eligibility Rule",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "ruleSetId",
          "label": "Rule Set",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": false,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.risk-rule",
      "name": "Risk Rule",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "ruleSetId",
          "label": "Rule Set",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": false,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.product-rule",
      "name": "Product Rule",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "ruleSetId",
          "label": "Rule Set",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": false,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.policy-rule",
      "name": "Policy Rule",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "ruleSetId",
          "label": "Rule Set",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": false,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.branch-rule",
      "name": "Branch Rule",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "ruleSetId",
          "label": "Rule Set",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": false,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "rules.customer-rule",
      "name": "Customer Rule",
      "category": "rules",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "condition",
          "label": "Condition",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "ruleSetId",
          "label": "Rule Set",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": false,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.rest-api",
      "name": "REST API",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "endpoint",
          "label": "Endpoint",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "method",
          "label": "Method",
          "type": "select",
          "options": [
            {
              "label": "GET",
              "value": "GET"
            },
            {
              "label": "POST",
              "value": "POST"
            },
            {
              "label": "PUT",
              "value": "PUT"
            },
            {
              "label": "PATCH",
              "value": "PATCH"
            },
            {
              "label": "DELETE",
              "value": "DELETE"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "headers",
          "label": "Headers",
          "type": "keyvalue",
          "tab": "configure"
        },
        {
          "key": "authType",
          "label": "Auth Type",
          "type": "select",
          "options": [
            {
              "label": "None",
              "value": "None"
            },
            {
              "label": "Basic",
              "value": "Basic"
            },
            {
              "label": "Bearer",
              "value": "Bearer"
            },
            {
              "label": "API Key",
              "value": "API Key"
            },
            {
              "label": "OAuth2",
              "value": "OAuth2"
            }
          ],
          "required": true,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.soap-api",
      "name": "SOAP API",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "endpoint",
          "label": "Endpoint",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "method",
          "label": "Method",
          "type": "select",
          "options": [
            {
              "label": "GET",
              "value": "GET"
            },
            {
              "label": "POST",
              "value": "POST"
            },
            {
              "label": "PUT",
              "value": "PUT"
            },
            {
              "label": "PATCH",
              "value": "PATCH"
            },
            {
              "label": "DELETE",
              "value": "DELETE"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "headers",
          "label": "Headers",
          "type": "keyvalue",
          "tab": "configure"
        },
        {
          "key": "authType",
          "label": "Auth Type",
          "type": "select",
          "options": [
            {
              "label": "None",
              "value": "None"
            },
            {
              "label": "Basic",
              "value": "Basic"
            },
            {
              "label": "Bearer",
              "value": "Bearer"
            },
            {
              "label": "API Key",
              "value": "API Key"
            },
            {
              "label": "OAuth2",
              "value": "OAuth2"
            }
          ],
          "required": true,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.graphql",
      "name": "GraphQL",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "endpoint",
          "label": "Endpoint",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "query",
          "label": "Query",
          "type": "code",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "variables",
          "label": "Variables",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.database-query",
      "name": "Database Query",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "connectionId",
          "label": "Connection",
          "type": "string",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "query",
          "label": "Query",
          "type": "code",
          "language": "sql",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.stored-procedure",
      "name": "Stored Procedure",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "connectionId",
          "label": "Connection",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "procedureName",
          "label": "Procedure Name",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "parameters",
          "label": "Parameters",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.webhook",
      "name": "Webhook",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "endpoint",
          "label": "Endpoint",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "method",
          "label": "Method",
          "type": "select",
          "options": [
            {
              "label": "GET",
              "value": "GET"
            },
            {
              "label": "POST",
              "value": "POST"
            },
            {
              "label": "PUT",
              "value": "PUT"
            },
            {
              "label": "PATCH",
              "value": "PATCH"
            },
            {
              "label": "DELETE",
              "value": "DELETE"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "payloadMapping",
          "label": "Payload Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.sftp",
      "name": "SFTP",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "host",
          "label": "Host",
          "type": "string",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "port",
          "label": "Port",
          "type": "number",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "remotePath",
          "label": "Remote Path",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.ftp",
      "name": "FTP",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "host",
          "label": "Host",
          "type": "string",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "port",
          "label": "Port",
          "type": "number",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "apiCredentialId",
          "label": "API Credential",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "remotePath",
          "label": "Remote Path",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.kafka",
      "name": "Kafka",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "connectionId",
          "label": "Connection",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "topicOrQueue",
          "label": "Topic / Queue",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "messageMapping",
          "label": "Message Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.rabbitmq",
      "name": "RabbitMQ",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "connectionId",
          "label": "Connection",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "topicOrQueue",
          "label": "Topic / Queue",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "messageMapping",
          "label": "Message Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.aws-sqs",
      "name": "AWS SQS",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "connectionId",
          "label": "Connection",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "topicOrQueue",
          "label": "Topic / Queue",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "messageMapping",
          "label": "Message Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.redis",
      "name": "Redis",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "connectionId",
          "label": "Connection",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        },
        {
          "key": "topicOrQueue",
          "label": "Topic / Queue",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "messageMapping",
          "label": "Message Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.email",
      "name": "Email",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.sms",
      "name": "SMS",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.whatsapp",
      "name": "WhatsApp",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.push-notification",
      "name": "Push Notification",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "integrations.webhook-response",
      "name": "Webhook Response",
      "category": "integrations",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "endpoint",
          "label": "Endpoint",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "method",
          "label": "Method",
          "type": "select",
          "options": [
            {
              "label": "GET",
              "value": "GET"
            },
            {
              "label": "POST",
              "value": "POST"
            },
            {
              "label": "PUT",
              "value": "PUT"
            },
            {
              "label": "PATCH",
              "value": "PATCH"
            },
            {
              "label": "DELETE",
              "value": "DELETE"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "payloadMapping",
          "label": "Payload Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "ai.ocr-ai",
      "name": "OCR AI",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.fraud-detection",
      "name": "Fraud Detection",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.document-classification",
      "name": "Document Classification",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.face-match",
      "name": "Face Match",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.name-match",
      "name": "Name Match",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.address-match",
      "name": "Address Match",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.income-prediction",
      "name": "Income Prediction",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.eligibility-prediction",
      "name": "Eligibility Prediction",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.risk-prediction",
      "name": "Risk Prediction",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.recommendation-engine",
      "name": "Recommendation Engine",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.chat-assistant",
      "name": "Chat Assistant",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.prompt-ai",
      "name": "Prompt AI",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.llm-completion",
      "name": "LLM Completion",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.llm-extract",
      "name": "LLM Extract",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "ai.llm-classification",
      "name": "LLM Classification",
      "category": "ai",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "model",
          "label": "Model",
          "type": "select",
          "options": [
            {
              "label": "claude-opus-5",
              "value": "claude-opus-5"
            },
            {
              "label": "claude-sonnet-5",
              "value": "claude-sonnet-5"
            },
            {
              "label": "claude-fable-5",
              "value": "claude-fable-5"
            },
            {
              "label": "claude-haiku-4-5-20251001",
              "value": "claude-haiku-4-5-20251001"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "promptTemplate",
          "label": "Prompt Template",
          "type": "textarea",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputFormat",
          "label": "Output Format",
          "type": "select",
          "options": [
            {
              "label": "Text",
              "value": "text"
            },
            {
              "label": "JSON",
              "value": "json"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "temperature",
          "label": "Temperature",
          "type": "number",
          "min": 0,
          "max": 1,
          "default": 0.7,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": true
      }
    },
    {
      "id": "decision.approve",
      "name": "Approve",
      "category": "decision",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "decision.reject",
      "name": "Reject",
      "category": "decision",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "decision.refer",
      "name": "Refer",
      "category": "decision",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "decision.manual-review",
      "name": "Manual Review",
      "category": "decision",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "decision.escalate",
      "name": "Escalate",
      "category": "decision",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "decision.reassign",
      "name": "Reassign",
      "category": "decision",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "decision.send-back",
      "name": "Send Back",
      "category": "decision",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "decision.need-more-documents",
      "name": "Need More Documents",
      "category": "decision",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "decision.need-verification",
      "name": "Need Verification",
      "category": "decision",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "approval.manager-approval",
      "name": "Manager Approval",
      "category": "approval",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "approval.branch-approval",
      "name": "Branch Approval",
      "category": "approval",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "approval.credit-approval",
      "name": "Credit Approval",
      "category": "approval",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "approval.risk-approval",
      "name": "Risk Approval",
      "category": "approval",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "approval.compliance-approval",
      "name": "Compliance Approval",
      "category": "approval",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "approval.legal-approval",
      "name": "Legal Approval",
      "category": "approval",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "approval.multi-level-approval",
      "name": "Multi-Level Approval",
      "category": "approval",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "approval.parallel-approval",
      "name": "Parallel Approval",
      "category": "approval",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "approved",
            "label": "Approved"
          },
          {
            "id": "rejected",
            "label": "Rejected"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "tasks.create-task",
      "name": "Create Task",
      "category": "tasks",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Maker",
              "value": "Maker"
            },
            {
              "label": "Checker",
              "value": "Checker"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Risk Officer",
              "value": "Risk Officer"
            },
            {
              "label": "Operations",
              "value": "Operations"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        },
        {
          "key": "priority",
          "label": "Priority",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            },
            {
              "label": "Urgent",
              "value": "Urgent"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "tasks.assign-task",
      "name": "Assign Task",
      "category": "tasks",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Maker",
              "value": "Maker"
            },
            {
              "label": "Checker",
              "value": "Checker"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Risk Officer",
              "value": "Risk Officer"
            },
            {
              "label": "Operations",
              "value": "Operations"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        },
        {
          "key": "priority",
          "label": "Priority",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            },
            {
              "label": "Urgent",
              "value": "Urgent"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "tasks.complete-task",
      "name": "Complete Task",
      "category": "tasks",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Maker",
              "value": "Maker"
            },
            {
              "label": "Checker",
              "value": "Checker"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Risk Officer",
              "value": "Risk Officer"
            },
            {
              "label": "Operations",
              "value": "Operations"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        },
        {
          "key": "priority",
          "label": "Priority",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            },
            {
              "label": "Urgent",
              "value": "Urgent"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "tasks.reassign-task",
      "name": "Reassign Task",
      "category": "tasks",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Maker",
              "value": "Maker"
            },
            {
              "label": "Checker",
              "value": "Checker"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Risk Officer",
              "value": "Risk Officer"
            },
            {
              "label": "Operations",
              "value": "Operations"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        },
        {
          "key": "priority",
          "label": "Priority",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            },
            {
              "label": "Urgent",
              "value": "Urgent"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "tasks.reminder",
      "name": "Reminder",
      "category": "tasks",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Maker",
              "value": "Maker"
            },
            {
              "label": "Checker",
              "value": "Checker"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Risk Officer",
              "value": "Risk Officer"
            },
            {
              "label": "Operations",
              "value": "Operations"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        },
        {
          "key": "priority",
          "label": "Priority",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            },
            {
              "label": "Urgent",
              "value": "Urgent"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "tasks.sla",
      "name": "SLA",
      "category": "tasks",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Maker",
              "value": "Maker"
            },
            {
              "label": "Checker",
              "value": "Checker"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Risk Officer",
              "value": "Risk Officer"
            },
            {
              "label": "Operations",
              "value": "Operations"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        },
        {
          "key": "priority",
          "label": "Priority",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            },
            {
              "label": "Urgent",
              "value": "Urgent"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "tasks.escalation",
      "name": "Escalation",
      "category": "tasks",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Maker",
              "value": "Maker"
            },
            {
              "label": "Checker",
              "value": "Checker"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Risk Officer",
              "value": "Risk Officer"
            },
            {
              "label": "Operations",
              "value": "Operations"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        },
        {
          "key": "priority",
          "label": "Priority",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            },
            {
              "label": "Urgent",
              "value": "Urgent"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "tasks.checklist",
      "name": "Checklist",
      "category": "tasks",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Maker",
              "value": "Maker"
            },
            {
              "label": "Checker",
              "value": "Checker"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Risk Officer",
              "value": "Risk Officer"
            },
            {
              "label": "Operations",
              "value": "Operations"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        },
        {
          "key": "priority",
          "label": "Priority",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            },
            {
              "label": "Urgent",
              "value": "Urgent"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "tasks.comment",
      "name": "Comment",
      "category": "tasks",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Maker",
              "value": "Maker"
            },
            {
              "label": "Checker",
              "value": "Checker"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Risk Officer",
              "value": "Risk Officer"
            },
            {
              "label": "Operations",
              "value": "Operations"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        },
        {
          "key": "priority",
          "label": "Priority",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            },
            {
              "label": "Urgent",
              "value": "Urgent"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "tasks.audit-note",
      "name": "Audit Note",
      "category": "tasks",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Maker",
              "value": "Maker"
            },
            {
              "label": "Checker",
              "value": "Checker"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Risk Officer",
              "value": "Risk Officer"
            },
            {
              "label": "Operations",
              "value": "Operations"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        },
        {
          "key": "priority",
          "label": "Priority",
          "type": "select",
          "options": [
            {
              "label": "Low",
              "value": "Low"
            },
            {
              "label": "Medium",
              "value": "Medium"
            },
            {
              "label": "High",
              "value": "High"
            },
            {
              "label": "Urgent",
              "value": "Urgent"
            }
          ],
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "communication.email",
      "name": "Email",
      "category": "communication",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "communication.sms",
      "name": "SMS",
      "category": "communication",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "communication.whatsapp",
      "name": "WhatsApp",
      "category": "communication",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "communication.push-notification",
      "name": "Push Notification",
      "category": "communication",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "communication.generate-letter",
      "name": "Generate Letter",
      "category": "communication",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "communication.generate-sanction-letter",
      "name": "Generate Sanction Letter",
      "category": "communication",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "communication.generate-welcome-letter",
      "name": "Generate Welcome Letter",
      "category": "communication",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "communication.generate-agreement",
      "name": "Generate Agreement",
      "category": "communication",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "communication.generate-noc",
      "name": "Generate NOC",
      "category": "communication",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "recipientField",
          "label": "Recipient Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "channel",
          "label": "Channel",
          "type": "select",
          "options": [
            {
              "label": "Email",
              "value": "Email"
            },
            {
              "label": "SMS",
              "value": "SMS"
            },
            {
              "label": "WhatsApp",
              "value": "WhatsApp"
            },
            {
              "label": "Push",
              "value": "Push"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "storage.save-entity",
      "name": "Save Entity",
      "category": "storage",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "entityType",
          "label": "Entity Type",
          "type": "select",
          "options": [
            {
              "label": "Applicant",
              "value": "Applicant"
            },
            {
              "label": "Customer",
              "value": "Customer"
            },
            {
              "label": "Opportunity",
              "value": "Opportunity"
            },
            {
              "label": "Document",
              "value": "Document"
            },
            {
              "label": "Guarantor",
              "value": "Guarantor"
            },
            {
              "label": "Co-Applicant",
              "value": "Co-Applicant"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "fieldMapping",
          "label": "Field Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "storage.update-entity",
      "name": "Update Entity",
      "category": "storage",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "entityType",
          "label": "Entity Type",
          "type": "select",
          "options": [
            {
              "label": "Applicant",
              "value": "Applicant"
            },
            {
              "label": "Customer",
              "value": "Customer"
            },
            {
              "label": "Opportunity",
              "value": "Opportunity"
            },
            {
              "label": "Document",
              "value": "Document"
            },
            {
              "label": "Guarantor",
              "value": "Guarantor"
            },
            {
              "label": "Co-Applicant",
              "value": "Co-Applicant"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "fieldMapping",
          "label": "Field Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "storage.delete-entity",
      "name": "Delete Entity",
      "category": "storage",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "entityType",
          "label": "Entity Type",
          "type": "select",
          "options": [
            {
              "label": "Applicant",
              "value": "Applicant"
            },
            {
              "label": "Customer",
              "value": "Customer"
            },
            {
              "label": "Opportunity",
              "value": "Opportunity"
            },
            {
              "label": "Document",
              "value": "Document"
            },
            {
              "label": "Guarantor",
              "value": "Guarantor"
            },
            {
              "label": "Co-Applicant",
              "value": "Co-Applicant"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "fieldMapping",
          "label": "Field Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "storage.search-entity",
      "name": "Search Entity",
      "category": "storage",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "entityType",
          "label": "Entity Type",
          "type": "select",
          "options": [
            {
              "label": "Applicant",
              "value": "Applicant"
            },
            {
              "label": "Customer",
              "value": "Customer"
            },
            {
              "label": "Opportunity",
              "value": "Opportunity"
            },
            {
              "label": "Document",
              "value": "Document"
            },
            {
              "label": "Guarantor",
              "value": "Guarantor"
            },
            {
              "label": "Co-Applicant",
              "value": "Co-Applicant"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "fieldMapping",
          "label": "Field Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "storage.create-record",
      "name": "Create Record",
      "category": "storage",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "entityType",
          "label": "Entity Type",
          "type": "select",
          "options": [
            {
              "label": "Applicant",
              "value": "Applicant"
            },
            {
              "label": "Customer",
              "value": "Customer"
            },
            {
              "label": "Opportunity",
              "value": "Opportunity"
            },
            {
              "label": "Document",
              "value": "Document"
            },
            {
              "label": "Guarantor",
              "value": "Guarantor"
            },
            {
              "label": "Co-Applicant",
              "value": "Co-Applicant"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "fieldMapping",
          "label": "Field Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "storage.archive-record",
      "name": "Archive Record",
      "category": "storage",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "entityType",
          "label": "Entity Type",
          "type": "select",
          "options": [
            {
              "label": "Applicant",
              "value": "Applicant"
            },
            {
              "label": "Customer",
              "value": "Customer"
            },
            {
              "label": "Opportunity",
              "value": "Opportunity"
            },
            {
              "label": "Document",
              "value": "Document"
            },
            {
              "label": "Guarantor",
              "value": "Guarantor"
            },
            {
              "label": "Co-Applicant",
              "value": "Co-Applicant"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "fieldMapping",
          "label": "Field Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "storage.version-record",
      "name": "Version Record",
      "category": "storage",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "entityType",
          "label": "Entity Type",
          "type": "select",
          "options": [
            {
              "label": "Applicant",
              "value": "Applicant"
            },
            {
              "label": "Customer",
              "value": "Customer"
            },
            {
              "label": "Opportunity",
              "value": "Opportunity"
            },
            {
              "label": "Document",
              "value": "Document"
            },
            {
              "label": "Guarantor",
              "value": "Guarantor"
            },
            {
              "label": "Co-Applicant",
              "value": "Co-Applicant"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "fieldMapping",
          "label": "Field Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.date",
      "name": "Date",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "format",
          "label": "Format",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.time",
      "name": "Time",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "format",
          "label": "Format",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.uuid",
      "name": "UUID",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "version",
          "label": "Version",
          "type": "select",
          "options": [
            {
              "label": "v4",
              "value": "v4"
            },
            {
              "label": "v1",
              "value": "v1"
            }
          ],
          "required": true,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.encrypt",
      "name": "Encrypt",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "algorithm",
          "label": "Algorithm",
          "type": "select",
          "options": [
            {
              "label": "AES-256",
              "value": "AES-256"
            },
            {
              "label": "RSA",
              "value": "RSA"
            },
            {
              "label": "SHA-256",
              "value": "SHA-256"
            },
            {
              "label": "bcrypt",
              "value": "bcrypt"
            }
          ],
          "required": true,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.decrypt",
      "name": "Decrypt",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "algorithm",
          "label": "Algorithm",
          "type": "select",
          "options": [
            {
              "label": "AES-256",
              "value": "AES-256"
            },
            {
              "label": "RSA",
              "value": "RSA"
            },
            {
              "label": "SHA-256",
              "value": "SHA-256"
            },
            {
              "label": "bcrypt",
              "value": "bcrypt"
            }
          ],
          "required": true,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.json",
      "name": "JSON",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "operation",
          "label": "Operation",
          "type": "select",
          "options": [
            {
              "label": "Parse",
              "value": "parse"
            },
            {
              "label": "Stringify",
              "value": "stringify"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "inputField",
          "label": "Input Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.xml",
      "name": "XML",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "operation",
          "label": "Operation",
          "type": "select",
          "options": [
            {
              "label": "Parse",
              "value": "parse"
            },
            {
              "label": "Stringify",
              "value": "stringify"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "inputField",
          "label": "Input Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.csv",
      "name": "CSV",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "operation",
          "label": "Operation",
          "type": "select",
          "options": [
            {
              "label": "Parse",
              "value": "parse"
            },
            {
              "label": "Stringify",
              "value": "stringify"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "inputField",
          "label": "Input Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.excel",
      "name": "Excel",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "operation",
          "label": "Operation",
          "type": "select",
          "options": [
            {
              "label": "Parse",
              "value": "parse"
            },
            {
              "label": "Stringify",
              "value": "stringify"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "inputField",
          "label": "Input Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "outputField",
          "label": "Output Field",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.expression",
      "name": "Expression",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "expression",
          "label": "Expression",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.mapper",
      "name": "Mapper",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "expression",
          "label": "Expression",
          "type": "code",
          "language": "expression",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.formatter",
      "name": "Formatter",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "formatPattern",
          "label": "Format Pattern",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "inputField",
          "label": "Input Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.variable",
      "name": "Variable",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "variableName",
          "label": "Variable Name",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "value",
          "label": "Value",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.environment",
      "name": "Environment",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "envKey",
          "label": "Environment Key",
          "type": "select",
          "options": [
            {
              "label": "NODE_ENV",
              "value": "NODE_ENV"
            },
            {
              "label": "API_BASE_URL",
              "value": "API_BASE_URL"
            },
            {
              "label": "LOG_LEVEL",
              "value": "LOG_LEVEL"
            },
            {
              "label": "FEATURE_FLAGS",
              "value": "FEATURE_FLAGS"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.secret",
      "name": "Secret",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "secretKey",
          "label": "Secret Key",
          "type": "select",
          "dynamicOptions": "secrets",
          "required": true,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "utility.logger",
      "name": "Logger",
      "category": "utility",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "level",
          "label": "Level",
          "type": "select",
          "options": [
            {
              "label": "Info",
              "value": "info"
            },
            {
              "label": "Warn",
              "value": "warn"
            },
            {
              "label": "Error",
              "value": "error"
            }
          ],
          "required": true,
          "tab": "configure"
        },
        {
          "key": "message",
          "label": "Message",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "workflow.start-workflow",
      "name": "Start Workflow",
      "category": "workflow",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "workflowId",
          "label": "Workflow",
          "type": "select",
          "dynamicOptions": "workflows",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "inputMapping",
          "label": "Input Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "workflow.invoke-workflow",
      "name": "Invoke Workflow",
      "category": "workflow",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "workflowId",
          "label": "Workflow",
          "type": "select",
          "dynamicOptions": "workflows",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "inputMapping",
          "label": "Input Mapping",
          "type": "keyvalue",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "workflow.reusable-workflow",
      "name": "Reusable Workflow",
      "category": "workflow",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "workflowId",
          "label": "Workflow",
          "type": "select",
          "dynamicOptions": "workflows",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "version",
          "label": "Version",
          "type": "select",
          "options": [
            {
              "label": "1.0.0",
              "value": "1.0.0"
            },
            {
              "label": "2.0.0",
              "value": "2.0.0"
            },
            {
              "label": "latest",
              "value": "latest"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "workflow.workflow-template",
      "name": "Workflow Template",
      "category": "workflow",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "templateId",
          "label": "Template",
          "type": "select",
          "options": [
            {
              "label": "Loan Origination",
              "value": "Loan Origination"
            },
            {
              "label": "KYC Onboarding",
              "value": "KYC Onboarding"
            },
            {
              "label": "Collections",
              "value": "Collections"
            },
            {
              "label": "Renewal",
              "value": "Renewal"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "workflow.workflow-version",
      "name": "Workflow Version",
      "category": "workflow",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "version",
          "label": "Version",
          "type": "string",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "changeNote",
          "label": "Change Note",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "workflow.publish-workflow",
      "name": "Publish Workflow",
      "category": "workflow",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "environment",
          "label": "Environment",
          "type": "select",
          "options": [
            {
              "label": "Staging",
              "value": "staging"
            },
            {
              "label": "Production",
              "value": "production"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "notifyOnPublish",
          "label": "Notify On Publish",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "workflow.rollback-workflow",
      "name": "Rollback Workflow",
      "category": "workflow",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "targetVersion",
          "label": "Target Version",
          "type": "select",
          "options": [
            {
              "label": "1.0.0",
              "value": "1.0.0"
            },
            {
              "label": "2.0.0",
              "value": "2.0.0"
            },
            {
              "label": "latest",
              "value": "latest"
            }
          ],
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": true,
        "humanInteraction": false,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "human-interaction.user-task",
      "name": "User Task",
      "category": "human-interaction",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "assignTo",
          "label": "Assign To",
          "type": "select",
          "options": [
            {
              "label": "Underwriter",
              "value": "Underwriter"
            },
            {
              "label": "Credit Officer",
              "value": "Credit Officer"
            },
            {
              "label": "Branch Manager",
              "value": "Branch Manager"
            },
            {
              "label": "Operations Team",
              "value": "Operations Team"
            },
            {
              "label": "Current User",
              "value": "Current User"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "instructions",
          "label": "Instructions",
          "type": "textarea",
          "tab": "setup"
        },
        {
          "key": "dueInHours",
          "label": "Due In (hours)",
          "type": "number",
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "human-interaction.review-screen",
      "name": "Review Screen",
      "category": "human-interaction",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "reviewTarget",
          "label": "Review Target",
          "type": "select",
          "options": [
            {
              "label": "Document",
              "value": "document"
            },
            {
              "label": "Form",
              "value": "form"
            },
            {
              "label": "Application",
              "value": "application"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "reviewerRole",
          "label": "Reviewer Role",
          "type": "select",
          "options": [
            {
              "label": "Manager",
              "value": "Manager"
            },
            {
              "label": "Credit",
              "value": "Credit"
            },
            {
              "label": "Risk",
              "value": "Risk"
            },
            {
              "label": "Compliance",
              "value": "Compliance"
            },
            {
              "label": "Legal",
              "value": "Legal"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "allowEdits",
          "label": "Allow Edits",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "human-interaction.approval-screen",
      "name": "Approval Screen",
      "category": "human-interaction",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "human-interaction.reject-screen",
      "name": "Reject Screen",
      "category": "human-interaction",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "label",
          "label": "Label",
          "type": "string",
          "tab": "setup"
        },
        {
          "key": "outcomeValue",
          "label": "Outcome Value",
          "type": "string",
          "required": true,
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "human-interaction.document-review",
      "name": "Document Review",
      "category": "human-interaction",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "reviewTarget",
          "label": "Review Target",
          "type": "select",
          "options": [
            {
              "label": "Document",
              "value": "document"
            },
            {
              "label": "Form",
              "value": "form"
            },
            {
              "label": "Application",
              "value": "application"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "reviewerRole",
          "label": "Reviewer Role",
          "type": "select",
          "options": [
            {
              "label": "Manager",
              "value": "Manager"
            },
            {
              "label": "Credit",
              "value": "Credit"
            },
            {
              "label": "Risk",
              "value": "Risk"
            },
            {
              "label": "Compliance",
              "value": "Compliance"
            },
            {
              "label": "Legal",
              "value": "Legal"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "allowEdits",
          "label": "Allow Edits",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "human-interaction.form-review",
      "name": "Form Review",
      "category": "human-interaction",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "reviewTarget",
          "label": "Review Target",
          "type": "select",
          "options": [
            {
              "label": "Document",
              "value": "document"
            },
            {
              "label": "Form",
              "value": "form"
            },
            {
              "label": "Application",
              "value": "application"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "reviewerRole",
          "label": "Reviewer Role",
          "type": "select",
          "options": [
            {
              "label": "Manager",
              "value": "Manager"
            },
            {
              "label": "Credit",
              "value": "Credit"
            },
            {
              "label": "Risk",
              "value": "Risk"
            },
            {
              "label": "Compliance",
              "value": "Compliance"
            },
            {
              "label": "Legal",
              "value": "Legal"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "allowEdits",
          "label": "Allow Edits",
          "type": "boolean",
          "default": false,
          "tab": "configure"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "human-interaction.manual-correction",
      "name": "Manual Correction",
      "category": "human-interaction",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "targetField",
          "label": "Target Field",
          "type": "select",
          "dynamicOptions": "formFields",
          "required": true,
          "tab": "setup"
        },
        {
          "key": "correctionReason",
          "label": "Correction Reason",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "human-interaction.customer-interaction",
      "name": "Customer Interaction",
      "category": "human-interaction",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "interactionType",
          "label": "Interaction Type",
          "type": "select",
          "options": [
            {
              "label": "Call",
              "value": "call"
            },
            {
              "label": "Meeting",
              "value": "meeting"
            },
            {
              "label": "Branch Visit",
              "value": "branch-visit"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "notes",
          "label": "Notes",
          "type": "textarea",
          "tab": "setup"
        },
        {
          "key": "scheduledAt",
          "label": "Scheduled At",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "human-interaction.rm-interaction",
      "name": "RM Interaction",
      "category": "human-interaction",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "out",
            "label": "Out"
          }
        ]
      },
      "properties": [
        {
          "key": "interactionType",
          "label": "Interaction Type",
          "type": "select",
          "options": [
            {
              "label": "Call",
              "value": "call"
            },
            {
              "label": "Meeting",
              "value": "meeting"
            },
            {
              "label": "Branch Visit",
              "value": "branch-visit"
            }
          ],
          "required": true,
          "tab": "setup"
        },
        {
          "key": "notes",
          "label": "Notes",
          "type": "textarea",
          "tab": "setup"
        },
        {
          "key": "scheduledAt",
          "label": "Scheduled At",
          "type": "string",
          "tab": "setup"
        }
      ],
      "capabilities": {
        "async": false,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": false,
        "aiPowered": false
      }
    },
    {
      "id": "data-display.dataset",
      "name": "Dataset",
      "category": "data-display",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "row-click",
            "label": "Row Click",
            "optional": true
          },
          {
            "id": "row-double-click",
            "label": "Row Double Click",
            "optional": true
          },
          {
            "id": "selection-change",
            "label": "Selection Change",
            "optional": true
          },
          {
            "id": "filter-change",
            "label": "Filter Change",
            "optional": true
          },
          {
            "id": "search",
            "label": "Search",
            "optional": true
          },
          {
            "id": "refresh",
            "label": "Refresh",
            "optional": true
          },
          {
            "id": "action-click",
            "label": "Action Click",
            "optional": true
          }
        ]
      },
      "properties": [],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    },
    {
      "id": "data-display.record-detail",
      "name": "Record Detail",
      "category": "data-display",
      "ports": {
        "inputs": [
          {
            "id": "in",
            "label": "In"
          }
        ],
        "outputs": [
          {
            "id": "action-click",
            "label": "Action Click",
            "optional": true
          },
          {
            "id": "back",
            "label": "Back",
            "optional": true
          }
        ]
      },
      "properties": [],
      "capabilities": {
        "async": true,
        "humanInteraction": true,
        "fileUpload": false,
        "externalIntegration": true,
        "aiPowered": false
      }
    }
  ]
}